import axios, {AxiosResponse} from "axios";
import {OrderSummaries} from "@/model/OrderSummaries";
import {OrderMonthlySummaries} from "@/model/OrderMonthlySummaries";
import {EmployeeSummaries} from "@/model/EmployeeSummaries";

const PATH = "/v2/statistics";

class StatisticServiceV2 {

  getOrderSummaries(month: string): Promise<AxiosResponse<OrderSummaries>> {
    return axios.get(`${PATH}/order-summaries`, {
      params: {
        month: month
      }
    });
  }

  getEmployeeSummaries(from: string, to: string): Promise<AxiosResponse<EmployeeSummaries>> {
    return axios.get(`${PATH}/employee-summaries`, {
      params: {
        from: from,
        to: to
      }
    });
  }

  getOrderMonthlySummaries(orderUuid: string, from: string, to: string): Promise<AxiosResponse<OrderMonthlySummaries>> {
    return axios.get(`${PATH}/orders/${orderUuid}/monthly-summaries`, {
      params: {
        from: from,
        to: to
      }
    });
  }
}

export default new StatisticServiceV2();
